import { render, staticRenderFns } from "./remixIcon.vue?vue&type=template&id=16dab434&scoped=true&"
import script from "./remixIcon.vue?vue&type=script&lang=js&"
export * from "./remixIcon.vue?vue&type=script&lang=js&"
import style0 from "./remixIcon.vue?vue&type=style&index=0&id=16dab434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dab434",
  null
  
)

export default component.exports